var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.4353C13.723 13.4353 15.1199 12.0384 15.1199 10.3153C15.1199 8.59218 13.723 7.19531 11.9999 7.19531C10.2768 7.19531 8.87988 8.59218 8.87988 10.3153C8.87988 12.0384 10.2768 13.4353 11.9999 13.4353Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61995 8.49391C5.58995 -0.166091 18.42 -0.156091 20.38 8.50391C21.53 13.5839 18.37 17.8839 15.6 20.5439C13.59 22.4839 10.41 22.4839 8.38995 20.5439C5.62995 17.8839 2.46995 13.5739 3.61995 8.49391Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f3dab70b0413acf7b1d183eb5e798b41.svg";
export { ForwardRef as ReactComponent };